import * as React from 'react';
import { RatioContainer } from '../../../RatioContainer';
import { YoutubeContent } from './components';
export var Youtube = function (props) {
    var link = props.link, description = props.description;
    return (React.createElement(RatioContainer, { aspectRatio: 16 / 9 },
        React.createElement(YoutubeContent, { link: link, description: description })));
};
